import React from "react";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "shared/components/buttons/Button";
import Icon, { ICONS } from "shared/components/Icon";
import InputMarkdown from "shared/components/inputs/InputMarkdown";
import InputText from "shared/components/inputs/InputText";

import "./style.scss";
import ManageChecklist from "containers/checklist/ManageChecklist";

const createDefaultChecklistItem = (label = "Item 1") => ({
    label,
    type: "CHECKBOX"
});

const createDefaultChecklist = () => ({
    label: "",
    description: "",
    items: [createDefaultChecklistItem()]
});

const normalizeChecklist = (checklist) => {
    if (!checklist) {
        return createDefaultChecklist();
    }

    const items = Array.isArray(checklist.items) && checklist.items.length > 0
        ? checklist.items.map((item, index) => ({
            label: item?.label || `Item ${index + 1}`,
            type: item?.type || "CHECKBOX"
        }))
        : [createDefaultChecklistItem()];

    return {
        id: checklist.id || null,
        label: checklist.label || "",
        description: checklist.description || "",
        items
    };
};

const MeasureTaskItem = ({ onChange, onDelete, task, index }) => {

    const { t } = useTranslation();
    const [label, setLabel] = useState(task?.label || "");
    const [description, setDescription] = useState(task?.description || "");
    const [hasChecklist, setHasChecklist] = useState(!!task?.checklist || !!task?.checklistId);
    const [checklist, setChecklist] = useState(normalizeChecklist(task?.checklist || (task?.checklistId ? { id: task.checklistId } : null)));
    const [open, setOpen] = useState(!task?.label);
    const [isChecklistOpen, setChecklistOpen] = useState(false);
    const checklistLabel = checklist?.label ? checklist.label : "";

    const onChecklistApplied = (nextChecklist) => {
        if (!nextChecklist) {
            setHasChecklist(false);
            setChecklist(createDefaultChecklist());
            return;
        }

        setHasChecklist(true);
        setChecklist(normalizeChecklist(nextChecklist));
    };


    // const onChecklistFieldChanged = (field, value) => {
    //     setChecklist({
    //         ...checklist,
    //         [field]: value
    //     });
    // };

    // const onChecklistItemChanged = (itemIndex, field, value) => {
    //     const items = [...checklist.items];
    //     items[itemIndex] = {
    //         ...items[itemIndex],
    //         [field]: value
    //     };

    //     setChecklist({
    //         ...checklist,
    //         items
    //     });
    // };

    // const onChecklistItemAdded = () => {
    //     setChecklist({
    //         ...checklist,
    //         items: [
    //             ...checklist.items,
    //             createDefaultChecklistItem(`Item ${checklist.items.length + 1}`)
    //         ]
    //     });
    // };

    // const onChecklistItemRemoved = (itemIndex) => {
    //     const items = checklist.items.filter((_, index) => index !== itemIndex);
    //     setChecklist({
    //         ...checklist,
    //         items: items.length > 0 ? items : [createDefaultChecklistItem()]
    //     });
    // };

    // const onChecklistToggle = () => {
    //     if (hasChecklist) {
    //         setHasChecklist(false);
    //         return;
    //     }

    //     setHasChecklist(true);
    //     setChecklist(normalizeChecklist(checklist));
    // };

    return (
        <div className="task-item">
            <div className="task-header">
                <span>{label}</span>
                <div className="toggle-open">
                    <div className="vertical-divider" />
                    <Icon name={ICONS.EDIT} onClick={() => setOpen(!open)} />
                </div>
            </div>
            {open &&
                <div className="task-form">
                    <InputText
                        label={t("measure.task.label")}
                        defaultValue={label}
                        onChange={({ target }) => setLabel(target.value)}
                        dark
                    />
                    <div className="cols">
                    <div className="col">
                        {isChecklistOpen ?
                            <ManageChecklist
                                applyChecklist={onChecklistApplied}
                                setActive={setChecklistOpen}
                                selectedChecklist={checklist}
                                index={0}
                            /> :
                            <div
                                className="checklist-view"
                                onClick={() => setChecklistOpen(true)}>
                                <InputText
                                    dataTestId={`manageChecklist${index}`}
                                    dark
                                    name="selectChecklist"
                                    value={checklistLabel}
                                    label={t("button.add.what",
                                        { what: t("checklist.singular") })}
                                    onClick={() => setChecklistOpen(true)}
                                    placeholder={t("button.select.what",
                                        { what: t("checklist.singular") })}
                                    readOnly
                                    iconRight={<Icon name={ICONS.LIST} />}
                                />
                            </div>
                        }
                    </div>
                </div>
                    <InputMarkdown
                        label={t("measure.task.description")}
                        defaultValue={description}
                        onChange={(markdown) => setDescription(markdown)}
                    />
                    <div className="spacer" />
                    <div className="spacer" />
                    <div className="container-buttons">
                        <Button
                            outlined
                            dark
                            spacedRight
                            label={t("button.delete.label")}
                            onClick={() => onDelete(index)}
                        />
                        <Button
                            disabled={label.length === 0}
                            dark
                            label={t("button.save.label")}
                            onClick={() => {
                                setOpen(false);
                                onChange(index, {
                                    label,
                                    description,
                                    checklist: hasChecklist ? checklist : null
                                    // checklist: hasChecklist ? checklist : null
                                });
                            }}
                        />
                    </div>
                </div>
            }

        </div>
    );
};


export default MeasureTaskItem;

MeasureTaskItem.propTypes = {
    task: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired
};




